"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropzoneForm = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var dropzone_preview_png_1 = __importDefault(require("../../static/images/dropzone-preview.png"));
var dropzone_1 = __importDefault(require("dropzone"));
var buttons_1 = require("../../ui/buttons");
function DropzoneForm(props) {
    var _a = (0, react_1.useState)(props.defaultImgUrl || dropzone_preview_png_1.default), thumbnail = _a[0], setThumbnail = _a[1];
    var _b = (0, react_1.useState)(), errorMessage = _b[0], setErrorMessage = _b[1];
    (0, react_1.useEffect)(function () {
        var myDropzone = new dropzone_1.default("#my-dropzone-container", {
            url: "/falsa",
            previewsContainer: "#my-dropzone-preview",
            maxFiles: 1,
            autoProcessQueue: false,
            maxFilesize: 2,
            thumbnailWidth: 333,
            thumbnailHeight: 147,
            resizeWidth: 333,
            resizeHeight: 147,
            resizeMethod: "contain",
            thumbnailMethod: "contain",
            clickable: "#button",
        });
        myDropzone.on("addedfile", function (file) {
            setErrorMessage(undefined);
        });
        myDropzone.on("maxfilesexceeded", function (file) {
            myDropzone.removeAllFiles();
            myDropzone.addFile(file);
        });
        myDropzone.on("thumbnail", function (file, dataURL) {
            setThumbnail(file.dataURL);
            props.cb(dataURL);
        });
        myDropzone.on("error", function (file, message) {
            setThumbnail(dropzone_preview_png_1.default);
            setErrorMessage(message);
            props.cb(undefined);
        });
    }, []);
    return (react_1.default.createElement("div", { className: index_css_1.default.container },
        react_1.default.createElement("img", { className: index_css_1.default["template-img"], src: thumbnail, alt: "template" }),
        errorMessage && react_1.default.createElement("p", null, errorMessage),
        react_1.default.createElement("div", { id: "my-dropzone-preview", className: index_css_1.default.preview }),
        react_1.default.createElement("div", { id: "my-dropzone-container" },
            react_1.default.createElement("div", { id: "button" },
                react_1.default.createElement(buttons_1.MainButton, { type: "button", color: "green" }, "Agregar/modificar foto")))));
}
exports.DropzoneForm = DropzoneForm;
